function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
import CaretDownSmallIcon from "@digital-hig/icon/lib/esm/ui-controls/caret-down-small";
export var makeAccordionStyles = function makeAccordionStyles(_ref) {
  var primitives = _ref.primitives,
    tokens = _ref.tokens;
  var borderRadius = primitives.borderRadii.large;
  return {
    MuiAccordion: {
      defaultProps: {
        elevation: 0
      },
      styleOverrides: {
        root: {
          "&::before": {
            background: "none"
          },
          margin: "".concat(primitives.spacings["2"], " ").concat(primitives.spacings["0"]),
          '& [class*="MuiAccordionSummary-root"]': {
            padding: "".concat(primitives.spacings["6"], " ").concat(primitives.spacings["5"], " ").concat(primitives.spacings["6"], "  ").concat(primitives.spacings["6"])
          },
          '& [class*="MuiAccordionDetails-root"]': {
            padding: "0 ".concat(primitives.spacings["6"], " ").concat(primitives.spacings["7"], " ").concat(primitives.spacings["6"])
          },
          "&.Mui-expanded": {
            margin: "".concat(primitives.spacings["2"], " ").concat(primitives.spacings["0"]),
            "&:hover": {
              background: tokens.colors["ink-on-fill-primary"]
            },
            "&:active": {
              background: tokens.colors["ink-on-fill-primary"]
            }
          },
          "&:first-of-type": {
            marginTop: primitives.spacings["0"]
          },
          "&:last-child": {
            marginBottom: primitives.spacings["0"]
          },
          "&:focus, &:focus-visible, &:focus-within": {
            zIndex: 1
          },
          "&.Mui-disabled": {
            backgroundColor: "initial",
            "&:hover": {
              background: tokens.colors["ink-on-fill-primary"]
            },
            "&:focus, &:focus-visible, &:focus-within": {
              boxShadow: "unset"
            },
            "&:active": {
              background: tokens.colors["ink-on-fill-primary"]
            }
          },
          "&.DhigAccordion--density--dense": {
            '& [class*="MuiAccordionSummary-root"]': {
              padding: "".concat(primitives.spacings["4"])
            },
            '& [class*="MuiAccordionDetails-root"]': {
              padding: "0 ".concat(primitives.spacings["4"], " ").concat(primitives.spacings["6"], " ").concat(primitives.spacings["4"])
            }
          },
          "&.DhigAccordion--variant--individualPanel": {
            boxShadow: tokens.effects["container-0"],
            "&:focus, &:focus-visible, &:focus-within": {
              '& [class*="MuiAccordionSummary-root"]': {
                borderRadius: borderRadius
              }
            }
          },
          "&.DhigAccordion--variant--individualPanel.Mui-expanded": {
            boxShadow: tokens.effects["container-1"],
            "&:focus, &:focus-visible": {
              border: "unset"
            }
          },
          "&.DhigAccordion--variant--flat:first-of-type": {
            borderTop: "".concat(primitives.borderWidths.medium, " solid ").concat(tokens.colors["detail-1-opaque"])
          },
          "&.DhigAccordion--variant--flat": {
            borderBottom: "".concat(primitives.borderWidths.medium, " solid ").concat(tokens.colors["detail-1-opaque"]),
            margin: 0,
            '& [class*="MuiAccordionSummary-root"]': {
              paddingLeft: primitives.spacings["4"],
              paddingRight: primitives.spacings["0"],
              "&::before, &::after": {
                borderRadius: primitives.spacings["0"]
              }
            },
            '& [class*="MuiAccordionDetails-root"]': {
              paddingLeft: primitives.spacings["0"],
              paddingRight: primitives.spacings["0"]
            },
            "&:not(:focus):not(:focus-visible):not(:focus-within)": {
              '& [class*="MuiAccordionSummary-root"]': {
                paddingLeft: primitives.spacings["0"],
                paddingRight: primitives.spacings["0"]
              },
              '& [class*="MuiAccordionDetails-root"]': {
                paddingLeft: primitives.spacings["0"]
              }
            },
            "&:focus-within": {
              '& [class*="MuiAccordionSummary-root"]:focus:not(:focus-visible)': {
                paddingLeft: primitives.spacings["0"]
              },
              '& [class*="MuiAccordionSummary-root"]:focus:not(:focus-visible) ~ [class*="MuiCollapse-root"] [class*="MuiAccordionDetails-root"]': {
                paddingLeft: primitives.spacings["0"]
              }
            }
          },
          "&.DhigAccordion--variant--mergedPanel:last-of-type": {
            borderBottomLeftRadius: primitives.spacings["2"],
            borderBottomRightRadius: primitives.spacings["2"],
            borderBottom: "".concat(primitives.borderWidths.medium, " solid ").concat(tokens.colors["detail-2-opaque"])
          },
          "&.DhigAccordion--variant--mergedPanel:first-of-type": {
            borderTopLeftRadius: primitives.spacings["2"],
            borderTopRightRadius: primitives.spacings["2"]
          },
          "&.DhigAccordion--variant--mergedPanel": {
            border: "".concat(primitives.borderWidths.medium, " solid ").concat(tokens.colors["detail-1-opaque-50"]),
            borderBottom: primitives.spacings["0"],
            borderRadius: primitives.spacings["0"],
            margin: primitives.spacings["0"],
            "&:focus, &:focus-visible, &:focus-within": {
              '& [class*="MuiAccordionSummary-root"]': {
                borderRadius: borderRadius
              }
            },
            "&:active": {
              background: "linear-gradient(270deg, rgba(43, 194, 117, 0.15) 0%, rgba(43, 194, 117, 0) 100%)"
            },
            "&.Mui-expanded:active": {
              backgroundImage: "none"
            },
            '& [class*="MuiAccordionDetails-root"]': {
              background: tokens.colors.background,
              borderBottomLeftRadius: primitives.borderRadii.large,
              borderBottomRightRadius: primitives.borderRadii.large,
              marginLeft: "1px",
              marginRight: "1px"
            }
          },
          "&.DhigAccordion--variant--minimal": {
            border: "none",
            margin: primitives.spacings["0"],
            '& [class*="MuiAccordionSummary-root"]': {
              paddingLeft: primitives.spacings["4"],
              paddingRight: primitives.spacings["3"],
              "&::before, &::after": {
                borderRadius: primitives.spacings["0"]
              }
            },
            '& [class*="MuiAccordionDetails-root"]': {
              paddingLeft: primitives.spacings["0"],
              paddingRight: primitives.spacings["0"]
            },
            "&:not(:focus):not(:focus-visible):not(:focus-within)": {
              '& [class*="MuiAccordionSummary-root"]': {
                paddingLeft: primitives.spacings["0"],
                paddingRight: primitives.spacings["3"]
              }
            },
            "&:focus-within": {
              '& [class*="MuiAccordionSummary-root"]:focus:not(:focus-visible)': {
                paddingLeft: primitives.spacings["0"]
              },
              '& [class*="MuiAccordionSummary-root"]:focus:not(:focus-visible) ~ [class*="MuiCollapse-root"] [class*="MuiAccordionDetails-root"]': {
                paddingLeft: primitives.spacings["0"]
              }
            },
            "&.Mui-disabled": {
              boxShadow: "none"
            }
          },
          "&.DhigAccordion--type--stepper": {
            '& [class*="MuiAccordionSummary-root"]': {
              "&::before, &::after": {
                borderRadius: primitives.spacings["0"]
              }
            },
            '& [class*="MuiAccordionSummary-content"]': {
              "& svg": {
                fontSize: primitives.spacings["7"],
                marginRight: primitives.spacings["3"]
              },
              '& [class*="MuiTypography-root"]:first-of-type': {
                marginTop: primitives.spacings["1"]
              }
            },
            '& [class*="MuiAccordionSummary-expandIconWrapper"]': {
              transform: "none",
              "& button": {
                padding: "".concat(primitives.spacings["2"], " ").concat(primitives.spacings["3"]),
                minWidth: "auto",
                fontSize: primitives.fontSizes["2"],
                height: "fit-content"
              }
            }
          },
          "&.DhigAccordion--size--normal.DhigAccordion--type--stepper": {
            '& [class*="MuiAccordionDetails-root"]': {
              paddingLeft: "calc(".concat(primitives.spacings["6"], " + ").concat(primitives.spacings["7"], " + ").concat(primitives.spacings["3"], ")"),
              background: tokens.colors.background
            }
          },
          "&.DhigAccordion--size--dense.DhigAccordion--type--stepper": {
            '& [class*="MuiAccordionDetails-root"]': {
              paddingLeft: "calc(".concat(primitives.spacings["4"], " + ").concat(primitives.spacings["7"], " + ").concat(primitives.spacings["3"], ")"),
              background: tokens.colors.background
            }
          }
        },
        rounded: {
          borderRadius: borderRadius,
          "&:first-of-type": {
            borderTopLeftRadius: borderRadius,
            borderTopRightRadius: borderRadius
          },
          "&:last-child": {
            borderBottomLeftRadius: borderRadius,
            borderBottomRightRadius: borderRadius
          }
        }
      }
    },
    MuiAccordionSummary: {
      defaultProps: {
        expandIcon: /*#__PURE__*/React.createElement(SvgIcon, null, /*#__PURE__*/React.createElement(CaretDownSmallIcon, null))
      },
      styleOverrides: {
        root: _objectSpread(_objectSpread({
          minHeight: primitives.spacings["0"],
          backgroundColor: "initial"
        }, tokens.transitions["state-blur"]), {}, {
          zIndex: 1,
          "&::before, &::after": _objectSpread(_objectSpread({
            content: "''",
            position: "absolute",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            zIndex: "-1",
            opacity: 0
          }, tokens.transitions["state-blur"]), {}, {
            borderRadius: borderRadius
          }),
          "&::before": _objectSpread({
            background: "linear-gradient(270deg, rgba(128, 128, 255, 0.2) 0%, rgba(128, 128, 255, 0) 100%)"
          }, tokens.transitions["state-activate"]),
          "&::after": _objectSpread({
            background: "linear-gradient(270deg, rgba(43, 194, 117, 0.15) 0%, rgba(43, 194, 117, 0) 100%)"
          }, tokens.transitions["state-activate"]),
          "&.Mui-expanded": {
            backgroundColor: "initial",
            minHeight: primitives.spacings["0"]
          },
          "&:hover:not(:active)::before": {
            opacity: 1
          },
          "&:focus": _objectSpread({
            boxShadow: tokens.effects["focus-ring-thin"]
          }, tokens.transitions["state-activate"]),
          "&:focus:not(:focus-visible)": {
            boxShadow: "none"
          },
          "&:focus-visible": _objectSpread({
            boxShadow: tokens.effects["focus-ring-thin"]
          }, tokens.transitions["state-activate"]),
          "&:active::after": {
            opacity: 1
          },
          "&.Mui-focused, &.Mui-focusVisible": {
            backgroundColor: "transparent"
          }
        }),
        content: {
          margin: primitives.spacings["0"],
          "&.Mui-expanded": {
            margin: primitives.spacings["0"]
          }
        },
        expandIconWrapper: {
          '& [class*="MuiSvgIcon-root"]': {
            color: tokens.colors["ink-on-background"],
            fontSize: primitives.spacings["6"]
          }
        }
      }
    },
    MuiAccordionDetails: {
      styleOverrides: {
        root: {
          flexDirection: "column",
          color: tokens.colors["text-on-background"]
        }
      }
    }
  };
};